/* eslint-disable no-shadow */
import {Typography} from 'components/Typography';
import {DetailedDescriptionImageCard} from 'modules/product-card/components/DetailedDescriptionImageCard';
import {FC} from 'react';
import style from './style.module.scss';
import {IFoodItem} from 'modules/product-card/types';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {selectProductData} from 'modules/product-card/selectors';
import {getProductCatalogPath} from 'modules/product-card/helpers';

interface IProps {
    imageList: IFoodItem[];
    title: string;
    value: string;
}

export const DetailedDescriptionItemImages: FC<IProps> = ({imageList, title, value}) => {
    const product = useAppSelector(selectProductData);
    if (!product) {
        return null;
    }

    const categoryPath = getProductCatalogPath(product);

    return (
        <div className={style.main}>
            <div className={style.textBlock}>
                <Typography variant={'title-18-m'}>{title}</Typography>
                <Typography variant={'body-16-r'}>{value}</Typography>
            </div>
            {0 < imageList.length && (
                <div className={style.imageList}>
                    {imageList.map(({imagePath, value, slug}) => {
                        return (
                            <DetailedDescriptionImageCard
                                categoryPath={categoryPath}
                                key={value}
                                image={imagePath}
                                slug={slug}
                                title={value}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};
